import './testimony.css'

function Testimony({data}) {
    return (
        <div className='testimony'>
           <div className='testimony--top'>
               <p>{data.desc}</p>
           </div>
           <div className="testimont--bottom">
               <img src={data.img} alt=''/>
               <h1>{data.name}</h1>
               <p>{data.career}</p>
           </div>
        </div>
    )
}

export default Testimony
